/* @flow */
import React from 'react';
import ReactDOM from 'react-dom';

import DOM from 'lib/DOM';
import Layer from 'components/Layer.jsx';

import LayerPropTypes from './lib/LayerPropTypes';

/**
 * A layer that adds an arrow element to point at its trigger.
 *
 * LayerWithArrow adds an arrow element that can be styled to point at the layer's trigger
 * element. This behavior is demonstrated by Hovercard.
 *
 * ```example
 *  <LayerTrigger
 *    layer={
 *      <Hovercard hideOnBlur={false} hideOnEscape={false}>
 *        <HovercardBody>
 *          This layer has an arrow.
 *        </HovercardBody>
 *      </Hovercard>
 *    }
 *    trigger="manual"
 *    defaultLayerShown={true}>
 *    <Link>This is the layer's trigger</Link>
 *  </LayerTrigger>
 * ```
 */

class LayerWithArrow extends React.Component {
  static propTypes = {
    ...LayerPropTypes,
    /** CSS class name to use on the arrow element */
    arrowClassName: React.PropTypes.string,
  };

  static defaultProps = {
    arrowClassName: null,
  };

  state = {
    arrowPosition: {},
  };

  componentDidMount() {
    if (this.props.arrowClassName !== null) {
      this.updateArrowPosition();
    }
  }

  componentWillReceiveProps() {
    if (this.props.arrowClassName !== null) {
      this.updateArrowPosition();
    }
  }

  updateArrowPosition() {
    const position = {};

    const node = ReactDOM.findDOMNode(this);
    const nodePosition = DOM.getOffset(node);
    const { context } = this.props;
    const contextPosition = DOM.getOffset(context);

    if (this.props.placement === 'bottom' || this.props.placement === 'top') {
      position.left = contextPosition.left + context.offsetWidth / 2 - nodePosition.left;
    } else if (this.props.placement === 'left' || this.props.placement === 'right') {
      position.top = contextPosition.top + context.offsetHeight / 2 - nodePosition.top;
    }

    this.setState({ arrowPosition: position });
  }


  render() {
    const { arrowClassName, ...others } = this.props;

    return (
      <Layer {...others}>
        {this.props.children}
        <div className={arrowClassName} style={this.state.arrowPosition} />
      </Layer>
    );
  }
}

export default LayerWithArrow;



// WEBPACK FOOTER //
// ./src/components/LayerWithArrow.jsx